import { FirebaseApp } from 'firebase/app';
import { Messaging, getMessaging, isSupported } from 'firebase/messaging';

export class SWFirebaseMessaging {
    private static instance: SWFirebaseMessaging | null = null;
    private messaging: Messaging | null;

    private constructor(messaging: Messaging | null) {
        this.messaging = messaging;
    }

    public static async getInstance(firebaseApp: FirebaseApp): Promise<SWFirebaseMessaging> {
        if (!SWFirebaseMessaging.instance) {
            const supported = await isSupported();
            SWFirebaseMessaging.instance = new SWFirebaseMessaging(supported ? getMessaging(firebaseApp) : null);
        }
        return SWFirebaseMessaging.instance;
    }

    public getMessaging(): Messaging | null {
        return this.messaging;
    }
}
